import React from 'react'
import TextwithImage from '../components/TextwithImage';
import CardSection from '../components/CardSection';
import GlobalHiring from '../components/GlobalHiring';
import DynamicClient from '../data/DynamicClient';
import TestimonialSlider from '../components/TestimonialSlider';
import TextContent from '../components/TextContent';
import BlogSection from '../components/BlogSection';
import {features_one } from '../data/CardData'
import { staffingtestimonials, staffingslidercontent } from '../data/Testimonialdata'
import Hero from '../components/Hero';
import { textSections }from '../data/TextwithimageData';
import { featureContentData_one } from '../data/CardSectionData';
import { headings, staffingservices } from '../data/GlobalHiringData';
import { useNavigate } from 'react-router-dom';

const Staffingsubpage = () => {
  const navigate = useNavigate();
  return (
  <>
  <Hero
      title="Talent Solutions for Tomorrow's Leaders"
      description="We provide comprehensive talent services designed to find, develop, and retain the leaders of tomorrow. Our approach ensures that your organization is always prepared for the future."
      buttonText="Connect with Expert"
      customClass="StaffingBanner"
      imageSrc="images/hero.png"
      squareColor="staffingsquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
  <TextwithImage data={textSections.pageOne} />
  <CardSection data={featureContentData_one} featuress={features_one} />
  <GlobalHiring services={staffingservices} heading={headings.page1}/>
  <TextContent/>
  <DynamicClient customClass="homepageclient"/>
  <TestimonialSlider testimonials={staffingtestimonials} sliderContent={staffingslidercontent} customClass="staffingtestimonial"/>
  <BlogSection/>
  
  </>
  );
}

export default Staffingsubpage